import { InlineMessage } from "@repo/ui/inline-message";
import { useStore } from "@repo/ui/store";
import { InfoRound } from "@/theme/icons/info-round";
import { TYPOGRAPHY_BODY3_SENTENCE } from "@/theme/topshop-2/typography/typography-constants";

// TODO: temporary solution until we have more clarity on how sitecore integration will work
const URLS: Record<string, string> = {
  GB: "https://www.asos.com/customer-care/technical/im-having-trouble-accessing-your-website-what-should-i-do/", // TODO: replace with the correct URL
};

export const NuanceErrorMessage = () => {
  const { countryData } = useStore();

  const url = URLS[countryData.storeCode] ?? URLS["GB"]!;

  return (
    <InlineMessage
      appearance="bordered"
      icon={<InfoRound />}
      inlineMessageClass={TYPOGRAPHY_BODY3_SENTENCE}
    >
      Oops! Something's gone wrong. Please check the following and try again:
      <br />
      You've only accepted third party cookies.
      <br />
      You only have one Topshop Help page window open.
      <br />
      You're not in incognito mode.
      <br />
      <a href={url} style={{ textDecoration: "underline" }}>
        Find more troubleshooting tips here.
      </a>
    </InlineMessage>
  );
};
